<template>
  <div>
    <small ref="subTitleFeatured"><span>Featured works</span></small>
    <div class="grid">
      <figure
        v-for="(item, index) in items"
        :key="item.slug"
        :class="['item-' + index]"
      >
        <router-link :to="{ path: '/works/' + item.slug }">
          <div :class="item.slug">
            <vector :src="require('#/image/logos/logo-' + item.slug + '.svg')" context="home-featured" />
          </div>
        </router-link>
      </figure>
    </div>
  </div>
</template>

<script>
import {TweenMax, Power3} from 'gsap'

export default {
  name: 'featured-grid',
  data () {
    return {
      itemHover: false,
      items: [
        {
          slug: 'olasio',
          hover: false
        },
        {
          slug: 'rbi-website',
          hover: false
        },
        {
          slug: 'transcope',
          hover: false
        },
        {
          slug: 'teamable',
          hover: false
        },
        {
          slug: 'biscuit',
          hover: false
        }
      ]
    }
  },
  mounted () {
    TweenMax.staggerFrom(
      '.grid > figure',
      1,
      {
        y: 50,
        opacity: 0,
        ease: Power3.easeOut,
        delay: 1.0
      },
      0.1
    ) // TweenMax

    TweenMax.from(
      this.$refs.subTitleFeatured,
      0.3,
      {
        opacity: 0,
        delay: 1.0
      }
    ) // TweenMax

    TweenMax.from(
      this.$refs.subTitleFeatured.querySelector('span'),
      1,
      {
        x: 100,
        opacity: 0,
        ease: Power3.easeOut,
        delay: 1.0
      }
    )
  }
}
</script>


<style lang="scss" scoped>
  $transition-ease: ease-in-out;

  .grid {
    width: 1140px;
    height: 1140px;
    display: grid;
    grid-gap: 12px;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);

    @include device(laptop) {
      width: 100%;
    }

    @include device(tablet) {
      height: 100%;
      grid-gap: 10px;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(3, 1fr);
    }
  }

  figure {
    & div {
      width: 100%;
      height: 100%;
      min-height: 372px;
      display: flex;
      flex-direction: column;
      color: #fff;
      background-color: $color-ghost;
      cursor: pointer;

      @include device(tablet) {
        min-height: 300px;
        background-size: cover;
      }

      @include device(mobile) {
        min-height: 200px;
      }

      // Specific projects
      &.olasio {
        background-color: #2D4866;
        background-image: url('/static/image/works/olasio/works-olasio-feat-cover.jpg');
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100%;
        transition: all 0.7s $transition-ease;
        transition-property: background-position;

        &:hover {
          background-position: bottom center;
        }

        & figure {
          width: 90px;
          height: 25px;
          position: absolute;
          top: 30px;
          left: 30px;

          @include device(mobile) {
            top: 30px;
            left: 30px;
            right: auto;
            bottom: auto;
          }
        }
      }

      &.rbi-website {
        background-color: #E52E4F;
        background-image: url('/static/image/works/rbi-website/works-rbi-feat-cover.jpg');
        background-repeat: no-repeat;
        background-position: top left;
        background-size: cover;
        transition: all 1s $transition-ease;
        transition-property: background-position;

        &:hover {
          background-position: top right;
        }

        & figure {
          width: 92px;
          height: 34px;
          position: absolute;
          top: 30px;
          left: 30px;
        }
      }

      &.transcope {
        background-color: #2A313D;
        background-image: url('/static/image/works/transcope/works-transcope-feat-cover.jpg');
        background-repeat: no-repeat;
        background-position: top left;
        background-size: cover;
        transition: all 0.6s $transition-ease;
        transition-property: background-position;

        @include device(tablet) {
          background-position: center left;
        }

        &:hover {
          background-position: top right;
        }

        & figure {
          width: 131px;
          height: 13px;
          position: absolute;
          top: 30px;
          left: 30px;
        }
      }

      &.teamable {
        background-color: #073F61;
        background-image: url('/static/image/works/teamable/works-teamable-feat-cover.jpg');
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 160%;
        transition: all 0.4s $transition-ease;
        transition-property: background-size;

        &:hover {
          background-size: 100%;
        }

        & figure {
          width: 115px;
          height: 35px;
          position: absolute;
          top: 30px;
          left: 30px;
        }
      }

      &.biscuit {
        background-color: #50CD7B;
        background-image: url('/static/image/works/biscuit/works-biscuit-feat-cover.jpg');
        background-repeat: no-repeat;
        background-position: top 50px center;
        background-size: 160%;
        transition: all 0.5s $transition-ease;
        transition-property: background-size, background-position;

        &:hover {
          background-position: top center;
          background-size: 100%;
        }

        & figure {
          width: 78px;
          height: 58px;
          position: absolute;
          top: 30px;
          left: 30px;
        }
      }
    }// div
  } // figure

  .item-0 {
    grid-column: 1 / 4;

    @include device(tablet) {
      grid-column: 1 / 3;
    }

    & div {
      justify-content: center;

      @include device(tablet) {
        padding: 30px;
      }
    }
  }

  .item-1 {
    grid-column: 1 / 3;

    @include device(tablet) {
      grid-column: 1 / 2;
    }

    @include device(mobile) {
      grid-column: 1 / 3;
    }

    & div {
      justify-content: center;
      
      @include device(tablet) {
      }
    }
  }

  .item-2 {
    grid-column: 3 / 4;
    grid-row: 2 / 4;

    @include device(tablet) {
      grid-column: 2 / 3;
      grid-row: 2 / 3;
    }

    @include device(mobile) {
      grid-column: 1 / 3;
    }

    & div {
      justify-content: flex-start;

      @include device(tablet) {
        justify-content: center;
      }
    }
  }

  .item-3, .item-4 {
    @include device(mobile) {
      grid-column: 1 / 3;
    }

    & div {
      justify-content: flex-end;

      @include device(tablet) {
        justify-content: center;
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/FeaturedGrid.vue